import axios, { type AxiosError, type AxiosInstance } from 'axios'
import { useUiStore } from '@/stores'
import { type FormData, type UiStore } from '@/types'
import { processApiError } from '@/utils'

const infraApi: AxiosInstance = axios.create({
    baseURL:
        `${import.meta.env.VITE_API_HOSTNAME}/infrastructure/` +
        `${import.meta.env.VITE_API_VERSION}`,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    },
    responseType: 'json',
    transitional: {
        forcedJSONParsing: true,
        silentJSONParsing: false,
    },
})

/**
 * Returns list of available user name objects for an input string
 * @param {string} name - user name
 * @returns {NameSuggestItem[]}
 */
export const sendLandingForm = async (data: FormData): Promise<void> => {
    await infraApi
        .post(
            '/landing-support',
            {
                birthDate: data.birthday,
                comment: data.comment,
                email: data.email,
                fullname: data.name,
                phone: data.phone,
            },
            {
                headers: {
                    Secret: import.meta.env.VITE_SECRET,
                },
            },
        )
        .then(() => {
            const uiStore: UiStore = useUiStore()
            uiStore.showSuccess('Данные успешно отправлены')
        })
        .catch((error: AxiosError) => {
            processApiError(error)
        })
}
